<template>
  <div>
    
    <crud-list :data-list="products">
      <template #beforeAdd>
        <filter-product/>
      </template>
      <template v-slot:listItem="{ listItem }">
        {{ listItem.name }}
      </template>
      <template  v-slot="{ form: item }">
        <form-product :toCopy="item.item" :operation="item.operation"/>
      </template>
    </crud-list>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import CrudList from "@/core/components/CrudList";
import FormProduct from "@/modules/product/components/FormProduct";
import FilterProduct from "@/modules/product/components/FilterProduct";

export default {
  name: 'Product',
  components:{
    FormProduct,
    CrudList,
    FilterProduct
  },
  computed: {
    ...mapState('products', ['products']),
  },
  created() {
    this.loadProducts()
  },
  updated() {
    this.loadList(this.products)
  },
  methods: {
    ...mapActions('products', ['loadProducts']),
    ...mapActions('crudList',['loadList'])
  },
}
</script>
